import React from "react";
import EditIcon from "../../../Icons/EditIcon";
import { Link } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const TableActionButton = (props: any) => {
  return (
    <Link to={props?.editPath} className={tw`cursor-pointer`}>
      <EditIcon color={"var(--primary)"} />
    </Link>
  );
};

export default TableActionButton;
